import { render, staticRenderFns } from "./RecursiveMenu.vue?vue&type=template&id=ec06ac7a&scoped=true"
import script from "./RecursiveMenu.vue?vue&type=script&lang=js"
export * from "./RecursiveMenu.vue?vue&type=script&lang=js"
import style0 from "./RecursiveMenu.vue?vue&type=style&index=0&id=ec06ac7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec06ac7a",
  null
  
)

export default component.exports